import { useEffect, useRef } from 'react';
import { matchPath, useLocation } from 'react-router-dom';

export const useScrollToTop = (element: Element | Window | null) => {
  const location = useLocation();

  useEffect(() => {
    element?.scrollTo(0, 0);
  }, [location, element]);
};

/**
 * Scrolls to the top of the element when the location.pathname is changed and none
 * of the provided excluded paths are matched. If the page has been previously scrolled
 * to, the scroll will also be rejected - this stops overlay open/clsoe from jumping to
 * the top
 *
 * @param element element to perform the scroll on
 * @param pathsToExclude a list of paths to exclude for the scroll
 */
export const useScrollToTopOnPathname = (
  element: Element | Window | null,
  pathsToExclude?: string[],
) => {
  const location = useLocation();
  const lastScrolled = useRef('');

  useEffect(() => {
    const isExcluded = pathsToExclude?.some(path => matchPath(location?.pathname, path)) ?? false;
    if (!isExcluded && location?.pathname !== lastScrolled.current) {
      lastScrolled.current = location?.pathname;
      element?.scrollTo(0, 0);
    }
  }, [pathsToExclude, location?.pathname, element]);
};
